export function nextDispatchDate(now = new Date(), timeZone = 'Europe/Paris') {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone, year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(now);
  const value = type => Number(parts.find(part => part.type === type).value);
  // Calendar arithmetic at UTC noon avoids daylight-saving-time offsets.
  const next = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + 2, 12));
  return next;
}

if (typeof customElements !== 'undefined' && !customElements.get('gv-dispatch-day')) {
  customElements.define('gv-dispatch-day', class extends HTMLElement {
    connectedCallback() {
      this.updateDate();
      this.timer = setInterval(() => this.updateDate(), 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    updateDate() {
      const date = nextDispatchDate(new Date(), this.dataset.timezone || 'Europe/Paris');
      const label = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(date);
      this.textContent = label.charAt(0).toUpperCase() + label.slice(1);
    }
  });
}
